// Thin wrappers over the event-settings HTTP endpoints. Kept as plain
// functions (not a class) so callers can compose them inside TanStack
// Query hooks without coupling this module to react-query.
//
// CSRF header is added automatically by `apiFetch` (http.js) for the
// mutating PUT path, so callers don't need to think about it.
import { apiGet, apiPut } from './http.js';

export function fetchEventSettings() {
  return apiGet('/api/event-settings');
}

export function updateEventSettings(payload) {
  return apiPut('/api/admin/event-settings', payload);
}
